var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransid = function SvgTransid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 91 57"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#transid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00538B",
    d: "M30.116 12.806v6.92h11.057v24.3h8.692v-24.3h11.03v-6.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F88D2A",
    d: "M81.892 22.802c0 5.504-3.11 10.546-8.266 14.478v13.667C84.196 45.727 91 37.63 91 28.527 91 12.774 70.627 0 45.497 0c-5.402 0-10.58.594-15.38 1.672v.194C34.916.766 40.1.178 45.496.178c3.613 0 7.127.266 10.499.777 14.981 2.821 25.896 11.529 25.896 21.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00538B",
    d: "M9.108 34.197c0-5.498 3.11-10.54 8.27-14.483V6.053C6.799 11.273 0 19.37 0 28.477 0 44.227 20.368 57 45.497 57c5.397 0 10.575-.594 15.387-1.677v-.188c-4.806 1.088-9.984 1.688-15.387 1.688a70 70 0 0 1-10.487-.778C20.023 53.224 9.103 44.516 9.103 34.197z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "transid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h91v57H0z"
  })))));
};
export default SvgTransid;